import {createFundamentalType, registerFundamentalNode} from "#template/fundamental/factory"
import {ImageInfo} from "#template/interface-descriptors"
import {imageMarker} from "#template/nodes/image/marker"
export {imageLikeMarker, isImageLikeNode, isImageLikeNodeClass, imageLike} from "#template/nodes/image/marker"
export type {ImageLikeNode} from "#template/nodes/image/marker"
export const ImageFT = createFundamentalType({
    name: "Image",
    marker: imageMarker,
    InfoClass: ImageInfo,
    icon: "far fa-image",
})

@registerFundamentalNode(ImageFT, "Likes")
export class ImageLikes extends ImageFT.Likes {}

@registerFundamentalNode(ImageFT, "Switch")
export class ImageSwitch extends ImageFT.Switch {}

@registerFundamentalNode(ImageFT, "Input")
export class ImageInput extends ImageFT.Input {}

@registerFundamentalNode(ImageFT, "Output")
export class ImageOutput extends ImageFT.Output {}

@registerFundamentalNode(ImageFT, "Export")
export class ImageExport extends ImageFT.Export {}
